/**
 * @file report.provider.tsx
 * @description Провайдер компонента отчетов для Task Manager приложения, который обеспечивает интеграцию контекста поиска с основным компонентом отчетов. Выступает в роли обертки высшего порядка (HOC) для предоставления SearchTextContext всем дочерним компонентам системы отчетности, обеспечивая централизованное управление состоянием поискового запроса в контексте генерации аналитических отчетов.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@features/catalog/context/search-text-context', './report.component']
 * @related-files ['src/features/report/report.component.tsx', 'src/features/report/index.js', 'src/features/catalog/context/search-text-context.tsx']
 */

import { SearchTextProvider } from '@features/catalog/context/search-text-context';
import { Report as ReportMain } from './report.component';

export const Report = (props: any) => {
    return (
        <SearchTextProvider>
            <ReportMain {...props} />
        </SearchTextProvider>
    );
};